import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import classNames from "classnames";

import { getToken } from "helpers/auth";
import { favoriteHelpers } from "helpers/favorite";

import Container from "components/grid/container";
import HighlighterTabWrapper from "components/homepage/highlighter-tab-wrapper";
import StickyFavoriteInfoBar from "components/common/sticky-favorite-info-bar";
import Loader from "components/loader";

import styles from "./styles.module.css";

const HighlighterTabs = ({ allHighlighterTabListingInfo }) => {
  const [lastViewKey, setLastViewKey] = useState(null);
  const [loading, setLoading] = useState(true);
  const getAllFavoritesByAccount = favoriteHelpers();
  const favoriteInfoBarButtonContent = useSelector((state) => state.favorite.favoriteInfoBarButtonContent);
  const favoriteInfoListingId = useSelector((state) => state.listingSearch.handleListingIdClickFavorite);
  const backButtonCondition = favoriteInfoBarButtonContent === "Geri Al";
  const title = lastViewKey === "Arsa" ? "Arsa Mı Arıyorsun?" : "Ev Mi Arıyorsun?";

  const wrapperClass = classNames({
    [styles.wrapper]: true,
    [styles.isLoading]: loading,
  });

  const titleClass = classNames({
    [styles.title]: true,
    [styles.loadingTitle]: loading,
  });

  const handleInfoBarSuccessCallback = async () => {
    await getAllFavoritesByAccount();
  };

  const getLastViewKeyFromStorage = () => {
    const lastViewKeyFromStorage = localStorage.getItem("last_view");
    if (lastViewKeyFromStorage) setLastViewKey(lastViewKeyFromStorage);
    setLoading(false);
  };

  useEffect(() => {
    if (getToken()) getAllFavoritesByAccount();
    getLastViewKeyFromStorage();
  }, []);

  /* useEffect(() => {
    if (allHighlighterTabListingInfo && Object.keys(allHighlighterTabListingInfo).length > 0) {
      setLoading(false);
    }
  }, [allHighlighterTabListingInfo]); */

  return (
    <div className={wrapperClass}>
      <Container>
        {loading && (
          <div className={styles.loaderWrapper}>
            <Loader />
          </div>
        )}
        <div className={styles.contentWrapper}>
          <h2 className={titleClass}>{!loading && title}</h2>
          <div className={styles.tabWrapper}>
            <HighlighterTabWrapper lastView={lastViewKey} allHighlighterTabListingInfo={allHighlighterTabListingInfo} />
          </div>
        </div>
      </Container>
      <StickyFavoriteInfoBar
        listingId={favoriteInfoListingId}
        successCallback={handleInfoBarSuccessCallback}
        backButtonCondition={backButtonCondition}
      />
    </div>
  );
};

HighlighterTabs.propTypes = {
  lastView: PropTypes.string,
  allHighlighterTabListingInfo: PropTypes.object,
};

export default HighlighterTabs;
